module.exports = __webpack_public_path__ + "media/images/wifi payant-be9b569ab934ee71ef9860f4c30ad01c.svg";